export enum Instancia {
  PRIMEIRO_GRAU = 'PRIMEIRO_GRAU',
  SEGUNDO_GRAU = 'SEGUNDO_GRAU',
  TERCEIRO_GRAU = 'TERCEIRO_GRAU',
  QUARTO_GRAU = 'QUARTO_GRAU'
}
